<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 20.5">
		<path fill="currentColor" d="M21.75 20.5h-21a.7502.7502 0 0 1-.75-.75v-19A.7502.7502 0 0 1 .75 0h16a.74942.74942 0 0 1 .53027.21973l5 5A.75027.75027 0 0 1 22.5 5.75v14a.7502.7502 0 0 1-.75.75ZM1.5 19H21V6.06055L16.43945 1.5H1.5Z"/>
		<path d="M13.75 6.5h-5A1.75213 1.75213 0 0 1 7 4.75v-4h1.5v4a.25048.25048 0 0 0 .25.25h5a.25048.25048 0 0 0 .25-.25v-4h1.5v4a1.75213 1.75213 0 0 1-1.75 1.75Z"/>
		<path d="M17.5 19.75H16v-6a.25048.25048 0 0 0-.25-.25h-9a.25048.25048 0 0 0-.25.25v6H5v-6A1.75213 1.75213 0 0 1 6.75 12h9a1.75213 1.75213 0 0 1 1.75 1.75Z"/>
	</svg>
</template>
